import React from "react";
import { Box, Button, useMediaQuery } from "@mui/material";
import { colors } from "src/config/colors";
import Price from "src/components/common/Price/Price";
import Typography from "@mui/material/Typography";
import { StyledSx } from "src/types/StyledSx";
import { Theme } from "@mui/system";

const styled: StyledSx = {
  root: {
    width: { xs: "120px", md: "155px" },
    height: "45px",
    textTransform: "none",
  },
};

interface ToBookButtonProps {
  price: any;
  onClick?: () => void;
  onOrder?: boolean;
}

export const ToBookButton: React.FC<ToBookButtonProps> = ({
  price,
  onClick,
  onOrder,
}) => {
  const isMediumScreenDown = useMediaQuery((theme: Theme) =>
    theme.breakpoints.up("md")
  );

  return (
    <Button
      variant="contained"
      sx={styled.root}
      disableElevation
      color="secondary"
      onClick={onClick}
    >
      <Box
        component="div"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        color={colors.yellow}
      >
        <Typography
          fontSize={{ xs: 11, md: 14 }}
          lineHeight="11px"
          color={colors.blue}
          component="span"
        >
          {onOrder ? "Под заказ" : "Забронировать"}
        </Typography>
        {!isMediumScreenDown && (
          <Price size="small" sx={{ color: "#fff" }} value={price} />
        )}
      </Box>
    </Button>
  );
};
